import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './CommonCard.css';

export default function CommonCard({ card_data }) {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out',
    });
  }, []);


  return (
    <div className='CommonCard-values-grid'>
      {
        card_data?.map((value, index) => {
          return (
            <div className="CommonCard-value-card" data-aos="fade-up" data-aos-delay="100" key={index}>
              <div className="CommonCard-value-icon header-2">
              <aside> { value.icon } </aside>
              </div>
              <h3 className="CommonCard-value-title">{value.title}</h3>
              <p className="CommonCard-value-description"> {value.msg} </p>
            </div>
          )
        })
      }
    </div>
  )
}
